/**
 * The way a school reaches LOQT from the help.
 *
 * One place for the address and for the wording of the subject, so the Help page, the contextual
 * help panels and the menu entry all open the same email.
 */

/** Where school queries go. */
export const CONTACT_SUPPORT_EMAIL = 'contact@loqt.app';

/** Subject of a query from a school whose name is not known yet. */
const UNKNOWN_SCHOOL_SUBJECT = 'Query from a school';

/** Subject of a query, naming the school so a reply does not have to ask who is writing. */
export function buildContactSubject(schoolName?: string | null): string {
  const name = schoolName?.trim();
  return name ? `Query from ${name}` : UNKNOWN_SCHOOL_SUBJECT;
}

/** The same query as a `mailto:` link, for a browser that has an email app to hand it to. */
export function buildContactMailtoUrl(schoolName?: string | null): string {
  return `mailto:${CONTACT_SUPPORT_EMAIL}?subject=${encodeURIComponent(buildContactSubject(schoolName))}`;
}

/**
 * Gmail's web compose, for a browser with no mail handler registered at all. It needs nothing of
 * the machine it runs on, so it works where `mailto:` silently does nothing.
 */
export function buildGmailComposeUrl(schoolName?: string | null): string {
  const subject = encodeURIComponent(buildContactSubject(schoolName));
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(CONTACT_SUPPORT_EMAIL)}&su=${subject}`;
}

/** The same, for the Outlook on the web account most schools sign in to. */
export function buildOutlookComposeUrl(schoolName?: string | null): string {
  const subject = encodeURIComponent(buildContactSubject(schoolName));
  return `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(CONTACT_SUPPORT_EMAIL)}&subject=${subject}`;
}
